export default {
  // Expandable calculator
  expandableCalculator: {
    title: 'Beregn din besparelse',
    subtitleCalculated: 'Se hvor meget du kan spare ved at skifte til enkel energi',
    ariaLabel: 'Beregn besparelse',
    closeButton: 'Luk',
    viewOptions: 'Se dine muligheder',
  },
  
  // Comparison widget
  comparisonTitle: 'Sammenlign elpriser',
  comparisonSubtitle: 'Se hvad du kan spare ved at skifte til enkel',
  yearlyConsumption: 'Årligt forbrug',
  yearlyCost: 'Årlig pris',
  monthlyCost: 'Månedlig pris',
  savings: 'Besparelse',
  savingsPerYear: 'Besparelse/år',
  cheapest: 'Billigst',
  mostExpensive: 'Dyrest',
  
  // Housing types
  selectHousingType: 'Vælg boligtype',
  house: 'Hus',
  apartment: 'Lejlighed',
  summerhouse: 'Sommerhus',
  withEV: 'Med elbil',
  withoutEV: 'Uden elbil',
  
  // Bar chart
  barChartTitle: 'Årlig pris hos forskellige udbydere',
  barChartSubtitle: 'Baseret på dit forbrug',
  youSave: 'Du sparer',
  comparedTo: 'sammenlignet med',
  
  // Price display
  pricePerKwh: 'Pris pr. kWh',
  spotPrice: 'Spotpris',
  subscription: 'Abonnement',
  totalPrice: 'Totalpris',
  
  // Data source
  dataSource: 'Kilde',
  dataUpdated: 'Data opdateret',
  basedOn: 'Baseret på',
  kwhPerYear: 'kWh/år',
  
  // Disclaimers
  pricesIncludeVat: 'Alle priser er inkl. moms',
  pricesExcludeGrid: 'Ekskl. nettariffer og afgifter',
  calculationNote: 'Beregningen er vejledende',

  // Widget-specific translations for ComparisonWidget
  selectProvider: 'Vælg elselskab',
  selectProviderPlaceholder: 'Vælg et elselskab',
  selectProduct: 'Vælg produkt',
  selectProductPlaceholder: 'Vælg et produkt',
  calculateSavings: 'Beregn besparelse',
  instructions: 'Vælg forbrug og elselskab for at se besparelse',
  youCanSave: 'Du kan spare',
  perYear: 'kr./år',
  saveCta: 'Spar',
  signUpHere: 'tilmeld dig her',
  details: 'Detaljer',
  noSavingsMessage: 'Du vil måske ikke spare ved at skifte til enkel energi, men der er meget mere end bare prisen:',
  benefit1: 'Spotpris uden tillæg',
  benefit2: 'Saving Mode app inkluderet',
  benefit3: 'Ingen binding',
  benefit4: 'Serviceaftale inkluderet',
  contactForMore: 'Kontakt os for mere information',
  dataFrom: 'Data fra:',
  spotSurcharge: 'Tillæg til spot',
  
  // Comparison notices for special providers
  comparisonNotices: {
    altid: 'Bemærk: Altids abonnementspris stiger baseret på dit faktiske forbrug. Hvis du overskrider dit estimerede forbrug, betaler du et højere månedligt gebyr end vist her.',
    enly: 'Bemærk: ENLY har en fastpris-model med ekstra gebyrer hvis dit forbrug overstiger den inkluderede mængde. Den faktiske pris kan være højere end vist.',
  },
  
  // Dynamic pricing translations
  dynamicPricing: {
    priceExplanation: 'Prisforklaring',
    priceExplanationDesc: 'Sådan er din elpris sammensat',
    typicalTotalPrice: 'Typisk totalpris',
    consumptionBasis: 'Beregningsgrundlag: {consumption} kWh/år',
    priceZone: 'Prisområde: {zone}',
    priceUpdated: 'Opdateret',
    estimatedPrices: 'Estimerede priser – Live-priser hentes',
    allPricesInclVat: 'Alle priser er inkl. moms (25%)',
    enkelElhandler: 'enkel (elhandler)',
    enkelExplanation: 'Dette er hvad du betaler til Enkel Energi. Vi fastsætter eller påvirker ikke net-tariffer eller afgifter.',
    spotPrice: 'Spotpris',
    spotSurcharge: 'Spotpris tillæg',
    subscription: 'Abonnement',
    consumptionSurcharge: 'Forbrugsafregning tillæg',
    yourGridCompany: 'Dit Netselskab ({name})',
    gridCompanyExplanation: 'Dit netselskab vælges efter din bopæl. Disse priser er regulerede og uden for Enkel Energis kontrol.',
    distribution: 'Distribution',
    total: 'Samlet',
    energinet: 'Energinet',
    tariffs: 'Tariffer',
    calculatedElTax: 'Beregnet el-afgift',
    elTax: 'El-afgift',
    vatExplanation: 'Spotpris {inclVat} øre/kWh inkl. moms ({vatOnly} øre moms af {exVat} øre)',
    calculatedPrice: 'Beregnede priser – kunne ikke hente live-priser',
    updatedPrice: 'Priser opdateret',
    enterPostalConsumption: 'Indtast postnummer og forbrug for præcise priser',
    postalPlaceholder: '2100',
  },
};